


import SECTION_BOARDGAMEBANNERSECTION from
'../dynamic_section/dynamic_2/template_01';





import SECTION_BOARDGAMECONTAINERSECTION from
'../dynamic_section/dynamic_1/template_01';



import "./style.css";


const BoardGamePageDesktop = ()=>{
  
return (
  <div id="boardGamePageDesktop" class="page ">
  
  

  
  < SECTION_BOARDGAMEBANNERSECTION desktopToggle={ true }
    mobileToggle={ false } label={ `boardgame_game_banner` } id={ `boardgame_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } numberOfImage={ 1 } titlePosition={ `start` }/>
  
  
  
  

  
  < SECTION_BOARDGAMECONTAINERSECTION desktopToggle={ true }
    mobileToggle={ false } label={ `Section_boardgame` } id={ `boardGameContainer` }
    imageSize={`1x2`} contentPosition={`bottom`}
    actionPosition={`hover`} rowDesktop={ 4 }
    rowMobile={ 3 } numberOfRow={ -1 }
    dataType={`game provider`} noPadding={ false } filter={`CB`}
    titleToggle={ false } titleIconToggle={ true }
    cardPosition={`start`} pagination={ true }
    autoplay={ true } navigation={ true }
    dynamicQuery={`` } filterTabToggle={ false }
    folderImage={``} noLink={ false }/>
  
  
  

  
</div>
)
}

export default BoardGamePageDesktop;